<script lang="ts">
  import { list } from '../../../../stores'
  import PreviewCard from '../../../../custom/PreviewCard/PreviewCard.svelte'
</script>

{#each $list as publication (publication.id)}
  <PreviewCard {publication} />
{/each}